import { ENDPOINT } from '~/constants/endpoints';

import { vestigasApi } from '~/services/kyClient';

import {
  type CreateCustomFieldPayload,
  type CreateCustomFieldResponse,
} from './types';
import { zodCreateCustomFieldPayloadSchema } from './validations';

/**
 * Creates a custom field.
 *
 * @param customFieldData - An object containing the custom field details to be created.
 * @returns A promise that resolves with the API response.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Custom-Field/operation/create_custom_field_custom_field_post
 */
export const createCustomField = async (
  customFieldData: CreateCustomFieldPayload,
) => {
  const response = await vestigasApi
    .post(ENDPOINT.CUSTOM_FIELD.CREATE(), {
      json: customFieldData,
      validate: {
        body: zodCreateCustomFieldPayloadSchema,
      },
    })
    .json<CreateCustomFieldResponse>();

  return response;
};
